import api from "../services/api";
import { get, set, clear } from "idb-keyval";
import { ping } from "./functions";

const EXCEPTIONS = {
  NOT_CACHEABLE: new DOMException("Dados não armazenáveis em cache", "NOT_CACHEABLE"),
  NOT_CACHED: new DOMException("Dados não disponíveis em cache", "NOT_CACHED"),
  DATA_UNDEFINED: new DOMException("Dados não definidos", "DATA_UNDEFINED"),
  DATA_INVALID: new DOMException("Dados no formato inválido", "DATA_INVALID"),
  STORAGE_ERROR: new DOMException("Armazenamento cheio ou desativado", "STORAGE_ERROR"),
}

class APICache {

  /**
   * 
   * @param {string} url 
   * @returns {"static"|"dynamic"}
   */
  static async getType(url) {
    const cached = await get(url);
    return cached ? cached.type : 'dynamic';
  }

  /**
   * 
   * @param {string} url 
   */
  static async isCacheable(url) {
    return await get(url) ? true : false;
  }

  /**
   * 
   * @param {string} url 
   */
  static async isCached(url) {
    if (!await APICache.isCacheable(url)) throw EXCEPTIONS.NOT_CACHEABLE;

    const cache = await get(url);
    if (!cache) return false;

    return true;
  }

  /**
   * 
   * @param {string} url 
   */
  static async fromCache(url) {
    if (!await APICache.isCacheable(url)) throw EXCEPTIONS.NOT_CACHEABLE;

    const cache = await get(url);
    if (!cache) throw EXCEPTIONS.NOT_CACHED;
    const data = cache.data;

    ping().then();
    return data;
  }

  /**
   * 
   * @param {string} url 
   * @param {("static"|"dynamic")} type
   * @param {{error: boolean}} data 
   */
  static async cache(url, type, data) {
    // if (!await APICache.isCacheable(url)) throw EXCEPTIONS.NOT_CACHEABLE;

    if (!type) type = await APICache.getType(url);

    if (!data) throw EXCEPTIONS.DATA_UNDEFINED
    if (data.error === undefined) throw EXCEPTIONS.DATA_INVALID;

    if (data.error === false) {
      try {
        await set(url, { version: (new Date()).toJSON(), type, data });
      } catch (error) {
        console.log(error);
        throw EXCEPTIONS.STORAGE_ERROR;
      }
    }
  }

  static async clearSession() {
    clear();
  }

  /**
   * 
   * @param {string} url 
   */
  static async fetch(url) {
    try {
      const response = await api.get(url, { force: true });
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}

export default APICache;